import React, { useContext, useMemo, useState } from 'react';
import { useMutation } from 'react-query';
import { useTranslation } from 'react-i18next';
import { useLegalEntitiesStore } from '../store';
import { DeleteModal } from '../../../../../../components/DeleteModal';
import { DeleteEntityModalContext } from './DeleteEntityModalContext';
import { ToastContext } from '@weezevent/nacre';

export const DeleteEntityModalProvider = ({ children }) => {
    const [openedId, setOpenedId] = useState(null);
    const { deleteEntity, getById } = useLegalEntitiesStore();
    const { t } = useTranslation();
    const entity = openedId ? getById(openedId) : null;
    const toaster = useContext(ToastContext);

    const closeModal = () => {
        setOpenedId(null);
    };

    const deleteMutation = useMutation(
        () => {
            return deleteEntity(openedId);
        },
        {
            onSuccess: () => {
                closeModal();
                toaster.success(t('sauron.financeModule.documentHeads.deleteModal.successToast'));
            }
        }
    );

    const value = useMemo(() => {
        return {
            open: setOpenedId
        };
    }, []);

    return (
        <DeleteEntityModalContext.Provider value={value}>
            <DeleteModal
                onSubmit={deleteMutation.mutate}
                onCancel={closeModal}
                isSubmitting={deleteMutation.isLoading}
                open={!!openedId}
                title={t('sauron.financeModule.documentHeads.deleteModal.title', {
                    name: entity?.name
                })}
                description={t('sauron.financeModule.documentHeads.deleteModal.description')}
            ></DeleteModal>
            {children}
        </DeleteEntityModalContext.Provider>
    );
};
